export const sidebar = [
  {
    url: "/dashboard/analytics",
    name: "Dashboard",
    slug: "Dashboard",
    icon: "HomeIcon",
    i18n: "SIDEBAR.dashboard",
    rule: ["express", "admin", "gotu"]
  },
  {
    url: "/dashboard/new/form",
    name: "NewForms",
    slug: "newForms",
    icon: "PackageIcon",
    i18n: "SIDEBAR.design",
    rule: "admin"
  },
  {
    header: "Formularios",
    icon: "LayersIcon",
    i18n: "SIDEBAR.HEADER.forms",
    rule: ["express", "admin", "gotu"],
    items: [
      {
        url: "/dashboard/forms",
        name: "eforms",
        slug: "dashboard-ecommerce",
        i18n: "SIDEBAR.Form-list",
        icon: "ClipboardIcon"
      },
      {
        url: "/dashboard/multiforms",
        name: "multiforms",
        slug: "Multiforms",
        i18n: "SIDEBAR.Multiforms",
        icon: "LayersIcon",
        feature: "multi_forms"
      },
      {
        url: "/dashboard/new/formularios",
        name: "NewForms",
        slug: "newForms",
        i18n: "SIDEBAR.design",
        icon: "PackageIcon"
      }
    ]
  },
  {
    url: "/dashboard/groups",
    slug: "page-groups",
    name: "Groups",
    icon: "UsersIcon",
    i18n: "SIDEBAR.groups",
    rule: ["express", "admin", "gotu"],
  },
  {
    header: "Usuarios",
    icon: "Edit3Icon",
    i18n: "SIDEBAR.HEADER.users",
    rule: ["admin", "gotu"],
    items: [
      {
        url: "/dashboard/users",
        name: "eusers",
        slug: "dashboard-ecommerce",
        i18n: "SIDEBAR.Users-list",
        icon: "UsersIcon"
      },
      {
        url: "/dashboard/users/assigned/bot",
        name: "eusersbot",
        slug: "dashboard-ecommerce",
        i18n: "SIDEBAR.assign-forms",
        icon: "LinkIcon",
        feature: "bot_forms"
      }
    ]
  },
  {
    header: "Visitas",
    icon: "MapPinIcon",
    i18n: "SIDEBAR.HEADER.visits",
    rule: ["admin", "gotu"],
    feature: "visits",
    items: [
      {
        url: "/dashboard/clients",
        name: "clientsvisit",
        slug: "clientsvisit",
        i18n: "SIDEBAR.clients",
        icon: "UsersIcon",
        feature: "visits"
      },
      {
        url: "/dashboard/visits",
        name: "moduleVisits",
        slug: "moduleVisits",
        i18n: "SIDEBAR.module-visits",
        icon: "MapPinIcon",
        feature: "visits"
      }
    ]
  },
  {
    header: "Panel de Control",
    icon: "FileIcon",
    i18n: "SIDEBAR.HEADER.controlPanel",
    rule: ["admin", "gotu"],
    items: [
      {
        url: "/dashboard/companies",
        slug: "page-companies",
        name: "companies",
        icon: "UserIcon",
        i18n: "SIDEBAR.companies"
      },
      {
        url: "/dashboard/access/tokens",
        slug: "page-tokens",
        name: "accessTokens",
        icon: "KeyIcon",
        i18n: "SIDEBAR.accessTokens"
      },
      {
        url: "/dashboard/datasource",
        slug: "page-datasource",
        name: "Datasource",
        icon: "SettingsIcon",
        i18n: "SIDEBAR.dataOrigin",
        feature: "data_origin"
      },
      {
        url: "/dashboard/connections",
        slug: "page-datasource",
        name: "Conections",
        icon: "ExternalLinkIcon",
        i18n: "SIDEBAR.conections",
        feature: "data_origin"
      },
      {
        url: "/dashboard/statistics",
        slug: "page-datasource",
        name: "Stadistics",
        icon: "TrendingUpIcon",
        i18n: "SIDEBAR.statistics",
        feature: "data_origin"
      },
      // {
      //   url: "/dashboard/keychains",
      //   slug: "page-status",
      //   name: "Keychains",
      //   icon: "MapIcon",
      //   i18n: "SIDEBAR.Keychains"
      // },
      {
        url: "/dashboard/transfer/forms",
        name: "transfer",
        slug: "transfer",
        icon: "RepeatIcon",
        i18n: "SIDEBAR.transfer"
      },
      {
        url: "/dashboard/migrate",
        name: "migrator",
        slug: "migrator",
        icon: "CopyIcon",
        i18n: "SIDEBAR.migrate"
      }
    ]
  }
];
import { permissions } from "@/acl/permitions.js";

export const EXCEPTION = (exeption, _sidebar) => {
  const permission = new permissions(true);
  return _sidebar.map(item => {
    if (item.feature && !permission.check(item.feature)) return false;

    let _Items = { ...item };
    if (item.hasOwnProperty("items"))
      _Items.items = item.items.filter(_items => {
        if (_items.feature) {
          return !exeption.includes(_items.name) && permission.check(_items.feature);
        }
        return !exeption.includes(_items.name);
      });
    return _Items;
  });
};
